<template>
	<div>
		<footer class="py-4 mt-4">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<div class="row">
							<div class="col-12 col-md-4  mb-5">
								<img src="https://cobraticket.uy/logo.svg" alt="" class="logo" />
								<div class="mt-4">
									<!-- <div>+598 98 370 416</div> -->
									<div>hola@cobraticket.uy</div>
								</div>
								<div class="redes">
									<!-- <div class="red">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-brand-facebook"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<path
												d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3"
											></path>
										</svg>
									</div> -->
									<!-- <div class="red">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-brand-twitter"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<path
												d="M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c-.002 -.249 1.51 -2.772 1.818 -4.013z"
											></path>
										</svg>
									</div> -->
									<!-- <div class="red">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-brand-instagram"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<rect x="4" y="4" width="16" height="16" rx="4"></rect>
											<circle cx="12" cy="12" r="3"></circle>
											<line x1="16.5" y1="7.5" x2="16.5" y2="7.501"></line>
										</svg>
									</div> -->
								</div>
							</div>
							<!-- <div class="col-12 col-md-4  mb-5 mt-4">
								<h4 class="footer-title">Nuestra empresa</h4>
								<router-link tag="a" :to="`/`"> Sobre nosotros</router-link><br />
								<router-link tag="a" :to="`/`"> Contacto</router-link><br />

								<h4 class="footer-title mt-5">¿Sos organizador de eventos?</h4>
								<router-link tag="a" :to="`/`"> Vende entradas con CobraTicket</router-link><br />
								<router-link tag="a" :to="`/campers`"> Servicios </router-link>
							</div>
							<div class="col-12 col-md-4  mb-5 mt-4">
								<h4 class="footer-title">Ayuda y soporte</h4>
								<router-link tag="a" :to="`/`"> Ayuda</router-link><br />
								<router-link tag="a" :to="`/campers`"> Mi cuenta </router-link><br />
								<router-link tag="a" :to="`/productos`"> Recuperar contraseña </router-link><br />
								<router-link tag="a" :to="`/quienes-somos`"> Terminos y condiciones </router-link><br />
								<router-link tag="a" :to="`/preguntas-frecuentes`"> Preguntas frecuentes </router-link
								><br />
								<router-link tag="a" :to="`/politica-privacidad`"> Política de privacidad</router-link>
							</div> -->
						</div>
					</div>
				</div>
			</div>
			<div class="container-fluid credits text-center p-3">
				<small>CobraTicket &copy; {{ year }} </small>
			</div>
		</footer>
	</div>
</template>

<script>
export default {
	name: "Footer",

	data() {
		return {
			year: new Date().getFullYear()
		}
	}
}
</script>

<style scoped lang="scss">
footer {
	margin-top: 32px;
	width: 100%;
	color: rgb(8, 8, 8);
	background-color: #fff;
}
.logo {
	max-width: 200px;
}
h5 {
	font-size: 15px;
}
.footer-title {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 6px;
}
a {
	color: rgb(8, 8, 8);
}

.redes {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	margin-top: 12px;
	flex-wrap: wrap;
}
.red {
	width: 38px;
	height: 38px;
	background-size: contain;
	background-repeat: no-repeat;
}

@media (max-width: 768px) {
	footer {
		text-align: center;
	}

	.redes,
	.payment-methods {
		justify-content: center;
	}
}
</style>
